export default __webpack_public_path__ + "static/media/kale_medika_logo.feeca3e7.png";